import PDFMerger from 'pdf-merger-js';

async function mergePdfs(fileurlPdf, fileurlMinutaPdf) {
    const merger = new PDFMerger();

    await merger.add(fileurlPdf);
    await merger.add(fileurlMinutaPdf);

    // Save to a Blob (browser) or file (Node.js)
    const mergedBuffer = await merger.saveAsBuffer();
    const mergedBlob = new Blob([mergedBuffer], { type: 'application/pdf' });
    const mergedUrl = URL.createObjectURL(mergedBlob);
    return mergedUrl;
}

export default mergePdfs;